// extracted by mini-css-extract-plugin
export default {"pagination":"dcclz3","arrow":"aC4Gop","page":"S51B8b","active":"Z1k0Ht"};